import { http, isRequestCanceled } from "../utils/httpCommon";
import { useState, useEffect } from "react";

const useFetchPostData = (url, passedDate) => {
  const [response, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const fetchData = async (signal) => {
    try {
      const res = await http.post(url, passedDate, signal ? { signal } : undefined);
      setData(res.data.data);
      setLoading(false);
    } catch (error) {
      if (isRequestCanceled(error)) return;
      setError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller.signal);
    return () => controller.abort();
    // Mount-only fetch; callers refetch via fetchData when inputs change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { response, error, loading, fetchData };
};

export default useFetchPostData;
